import React from 'react'
import { sample } from 'lodash'

export const gallery1 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 335 219"
    preserveAspectRatio="xMidYMid meet"
  >
    <polygon
      fillRule="evenodd"
      points="52 0 52 122.666 0 122.666 0 218.667 334.667 218.667 334.667 46.667"
    />
  </svg>
)

export const gallery2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 517 199"
    preserveAspectRatio="xMidYMid meet"
  >
    <polygon
      fillRule="evenodd"
      points="269.007 0 145.116 .063 145.116 150.283 0 150.283 0 198.487 516.79 198.487 516.79 150.283 395.86 150.283 395.86 .063 360.322 .063 360.322 25.729 308.001 75.583 269.007 75.583"
    />
  </svg>
)

export const gallery3 = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 449 285">
    <polygon
      fillRule="evenodd"
      points="111.116 .001 111.116 119.608 0 119.608 0 165.613 111.116 165.613 111.116 284.513 146.503 284.513 336.761 284.513 336.909 165.613 448.54 165.613 448.54 119.608 338.304 119.607 338.301 .001"
    />
  </svg>
)

export const gallery4 = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 428 403">
    <polygon
      fillRule="evenodd"
      points="136.527 .001 136.527 27.635 58.5 27.635 58.5 154.688 0 154.688 0 279.001 176.414 279.001 316.264 402.399 427.78 402.399 427.78 154.688 316.264 154.688 176.413 154.688 176.413 27.635 176.413 .001"
    />
  </svg>
)

export const gallery5 = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 463 402">
    <g fillRule="evenodd">
      <polygon points="76.335 0 76.335 47.196 1 47.196 1 123.248 76.335 123.248 76.335 202.018 132.782 202.018 132.862 202.431 334.88 202.431 322.836 139.907 278.353 139.907 278.353 62.523 307.06 62.523 295.017 0" />
      <polygon points="365.927 285.658 320.992 335.163 255.702 335.163 255.702 401.17 463.051 401.17 463.051 351.665 463.051 335.163 463.051 285.658" />
    </g>
  </svg>
)

export const gallery6 = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 379 318">
    <path
      fillRule="evenodd"
      d="M378.6035,200.2219 L378.6035,112.0849 L102.2915,112.0849 L102.2915,-0.0001 L-0.0005,-0.0001 L-0.0005,317.8839 L67.2495,317.8839 L67.2495,256.2999 L149.3665,256.2999 L149.3665,294.4089 L222.3315,294.4089 L222.3315,266.7859 C265.5955,230.5669 319.4625,206.6009 378.6035,200.2219"
    />
  </svg>
)

export const gallery7 = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 357">
    <polygon
      fillRule="evenodd"
      points="354.942 0 354.942 64.528 186.069 64.528 186.069 0 2.094 0 0 98.166 91.337 194.958 184.698 194.958 184.698 356.965 235.497 356.965 235.497 259.486 258.21 289.572 387.028 356.965 419.47 356.965 419.47 0"
    />
  </svg>
)

export default sample([
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
])
